module.exports = __webpack_public_path__ + "img/SILHOUETTE_FICHE_INDIV_DEFAUT.35e64bdb.svg";